import _defineProperty from "/vercel/path0/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React, { createContext, useContext, useEffect, useState } from 'react';
import { connect } from 'react-redux';
import SignupFlow from '../components/SignupFlow';
import { requestLogin as requestLoginAction, signup as signUpAction } from '../state/actions';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var defaultValues = {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  doSignup: function doSignup(redirectUrl) {
    return void 0;
  }
};
export var SignupContext = /*#__PURE__*/createContext(defaultValues);
export var SignupProvider = function SignupProvider(_ref) {
  var children = _ref.children;

  var _useState = useState(null),
      currentAuthStep = _useState[0],
      setCurrentAuthStep = _useState[1];

  var _useState2 = useState(''),
      email = _useState2[0],
      setEmail = _useState2[1];

  var _useState3 = useState(''),
      redirect = _useState3[0],
      setRedirect = _useState3[1];

  var doSignup = function doSignup(redirectUrl) {
    if (redirectUrl) setRedirect(redirectUrl);
    setCurrentAuthStep('login');
  };

  return /*#__PURE__*/_jsxs(SignupContext.Provider, {
    value: {
      doSignup: doSignup
    },
    children: [children, /*#__PURE__*/_jsx(SignupFormContainer, {
      currentAuthStep: currentAuthStep,
      setCurrentAuthStep: setCurrentAuthStep,
      email: email,
      setEmail: setEmail,
      redirect: redirect
    })]
  });
}; // extra component bc redux's connect() doesn't take a Context

var SignupFormContainerComponent = function SignupFormContainerComponent(_ref2) {
  var currentAuthStep = _ref2.currentAuthStep,
      setCurrentAuthStep = _ref2.setCurrentAuthStep,
      email = _ref2.email,
      setEmail = _ref2.setEmail,
      requestLogin = _ref2.requestLogin,
      signup = _ref2.signup,
      redirect = _ref2.redirect,
      loginRequestSent = _ref2.loginRequestSent;
  useEffect(function () {
    if (email && loginRequestSent) {
      setCurrentAuthStep('confirm-email-dialog');
    }
  }, [loginRequestSent, email]);

  var onSignupFormSubmit = function onSignupFormSubmit(formData) {
    setEmail(formData.email);
    signup(_objectSpread(_objectSpread({}, formData), {}, {
      redirect: redirect || ''
    })).then(function (user) {
      if (user !== null && user !== void 0 && user.id) {
        setCurrentAuthStep('confirm-email-dialog');
      }
    });
  };

  var onLoginFormSubmit = function onLoginFormSubmit(formData) {
    setEmail(formData.email);
    requestLogin(_objectSpread(_objectSpread({}, formData), {}, {
      redirect: redirect
    })).then(function (response) {
      var _response$data;

      if (!response) {
        return;
      }

      if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 401) {
        setCurrentAuthStep('enter-email');
      }
    });
  };

  return /*#__PURE__*/_jsx(SignupFlow, {
    email: email,
    step: currentAuthStep,
    onLoginFormSubmit: onLoginFormSubmit,
    onSignupFormSubmit: onSignupFormSubmit,
    setStep: setCurrentAuthStep
  });
};

var mapStateToProps = function mapStateToProps(state) {
  return {
    loginRequestSent: state.auth.loginRequestSent
  };
};

var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    requestLogin: function requestLogin(payload) {
      return dispatch(requestLoginAction(payload, // Don't show "user does not exist" error on login failure
      false));
    },
    signup: function signup(payload) {
      return dispatch(signUpAction(payload));
    }
  };
};

var SignupFormContainer = connect(mapStateToProps, mapDispatchToProps)(SignupFormContainerComponent); // import this one to use the SignUp Provider, and call doSignup(url):

export var useSignupProvider = function useSignupProvider() {
  return useContext(SignupContext);
};